module.exports = __webpack_public_path__ + "static/img/avatar-icon.bb54648.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rebateUI1/avatar-icon.png
// module id = FmRG
// module chunks = 39